module.exports = __webpack_public_path__ + "img/schnittkante_gruen_candy.50a63415.jpg";